import { render, staticRenderFns } from "./ListContanctProviderDisabledComponent.vue?vue&type=template&id=953f8c74"
import script from "./ListContanctProviderDisabledComponent.vue?vue&type=script&lang=js"
export * from "./ListContanctProviderDisabledComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports